import styled from 'styled-components'
import { screenSizes } from '../../constants/breakpoints'

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  gap: 2em;
`

export const Main = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: start;
  gap: 1em;
  padding: 0 2em;
  max-width: 1140px;
  @media (max-width: ${screenSizes.mediaMM}px) {
    padding: 1em 10px 0em 10px;
  }
  @media (max-width: ${screenSizes.mediaXS}px) {
    padding: 1em 0em 2em 0em;
  }
  padding-top: 64px;
`
export const TblContainer = styled.div`
  td {
    border: 1px solid white;
    color: white;
    padding: 0 5px;
    vertical-align: top;
    @media (max-width: ${screenSizes.mediaXS}px) {
      p {
        font-size: 14px;
      }
    }
    @media (max-width: 400px) {
      p {
        font-size: 12px;
      }
    }
  }
`
export const CardBodyTextCntr = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 14px;
  max-width: 95vw;
  li::marker {
    color: ${(props: any) => props.theme.lightGray};
  }
  li {
    padding: 0;
  }
  ol, ul {
    padding-left: 30px;
  }
`

export const AnchorInLine = styled.a`
  position: relative;
  display: inline-block;
  color: ${(props: any) => props.theme.linkBlue};
  font-size: 14px;
  line-height: 20px;
  font-family: 'lexend';
  font-weight: 400;
  line-height: 20px;
  text-decoration: underline;
  &:hover {
    opacity: 0.7;
  }
`
interface IDisclaimerContainer {
  align?: string
}

export const DisclaimerContainer = styled.div<IDisclaimerContainer>`
  display: flex;
  align-items: ${(props: any) => props.align || 'center'};
  border-radius: 12px;
  background: ${(props: any) => props.theme.khaki2};
  padding: 8px;
  gap: 2px;
`
export const PaddedContent = styled.div`
  padding-left: 32px;
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 14px;
`

export const PaddedUL = styled.ul`
  li {
    padding: 8px 0;
  }
  ol > li {
    padding: 0;
  }
  
`


interface ITableContainerProps {
  borderless?: boolean
}
export const TableContainer = styled.div<ITableContainerProps>`
  border-radius: 6px;
  border: ${props => props.borderless ? 'none' : '1px solid rgb(0 0 0 / 10%)'};
  width: 100%;
  overflow: auto;
  table {
    border-collapse: collapse;
    width: 100%;
  }
  thead {
    tr {
      border-radius: 5px;
      background: ${(props) => props.theme.primaryGreen};
    }
    th {
      padding: 16px;
      background: ${(props) => props.theme.primaryGreen};
    }
  }
  table th:first-child {
    position: relative;
    border-radius: 5px 0 0 5px;
  }

  table th:last-child {
    border-radius: 0 5px 5px 0;
  }

  .prefixThead {
    .prefixTr {
      border-radius: 5px;
      background: transparent;
    }
    .prefixTh {
      padding: 0px 10px;
      background: transparent;
    }
  }

  
  tbody {
    tr {
      /* border-bottom: 1px solid ${(props) => props.theme.tintsGray}; */
      transition: 0.2s linear;
      &:hover {
        background-color: ${(props) => props.theme.tintsGray};
      }
      td:first-child {
        width: 25px;
      }
    }
    td {
      padding: 12px 16px;
    }
    
  }

  tr:nth-child(2n) {
    background: ${(props) => props.theme.tertiary};
  }
  .copyIcon:hover {
    transform: scale(1.2);
    transition: all .1s ease-in;
    cursor: pointer;
  }
`

export const TableWrapper = styled(TableContainer)`
  p {
    max-width: 180px;
  }
  @media (min-width: 1000px)  {
    p {
      min-width: 180px;
    }
  }
`